module.exports = __webpack_public_path__ + "img/products6.b2749477.jpg";